// extracted by mini-css-extract-plugin
export var pageCopy = "ContentfulBlockCopy-module--pageCopy--ANXYe";
export var padded = "ContentfulBlockCopy-module--padded--e26eH";
export var textSizeStandard = "ContentfulBlockCopy-module--textSizeStandard--cn31M";
export var textSizeLarge = "ContentfulBlockCopy-module--textSizeLarge---EqPU";
export var separatorToponly = "ContentfulBlockCopy-module--separatorToponly--OUl5g";
export var separatorBottomonly = "ContentfulBlockCopy-module--separatorBottomonly--vu7Px";
export var separatorTopandBottom = "ContentfulBlockCopy-module--separatorTopandBottom--JHYI2";